import { render, staticRenderFns } from "./possui-sede.vue?vue&type=template&id=e1847a96"
import script from "./possui-sede.vue?vue&type=script&lang=js"
export * from "./possui-sede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports